export function scrollChatDown() {
  const messages = document.getElementById("messages");
  if(messages)
    messages.scrollTop = messages.scrollHeight;
}
